import React from 'react';
import _ from 'lodash';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as organisationsActions from 'app/ducks/organisations/actions';
import * as competitionsActions from 'app/ducks/competitions/actions';
import * as paymentEventsActions from 'app/ducks/paymentEvents/actions';
import * as subscriptionPaymentActions from 'app/ducks/subscriptionPayments/actions';
import * as paymentEventImportsActions from 'app/ducks/paymentEventImports/actions';
import * as paymentEventDashboardActions from 'app/ducks/paymentEventDashboard/actions';

import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import * as paymentEventSelectors from 'app/ducks/paymentEvents/selectors';
import * as paymentEventImportSelectors from 'app/ducks/paymentEventImports/selectors';

import RenderContent from 'app/components/layout/RenderContent';
import ImportEvents from './components/ImportEvents';
import EventDashboardSimple from './components/EventDashboardSimple';


function selector(state): any {
  return {
    organisations: organisationSelectors.getOrganisations(state),
    competitions: competitionSelectors.getCompetitions(state),
    paymentEvents: paymentEventSelectors.getPaymentEvents(state),
    subscriptionPayments: state.subscriptionPayments,
    paymentEventDashboard: state.paymentEventDashboard,
    paymentEventImports: paymentEventImportSelectors.getPaymentEventImports(
      state,
    ),
  };
}

const actionCreators = _.merge(
  organisationsActions,
  competitionsActions,
  paymentEventsActions,
  paymentEventImportsActions,
  subscriptionPaymentActions,
  paymentEventDashboardActions,
);

interface IEventsLayoutProps {
  appReady: boolean;
  actions: any;
  organisations: any;
  competitions: any;
  paymentEvents: any;
  paymentEventDashboard: any;
  subscriptionPayments: any;
  match: any;
}

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class EventsLayout extends React.Component<IEventsLayoutProps> {
  static defaultProps = {
    appReady: false,
    actions: undefined,
    organisations: undefined,
    competitions: undefined,
    paymentEvents: undefined,
    paymentEventDashboard: undefined,
    subscriptionPayments: undefined,
    match: undefined,
  };

  render(): React.ReactNode {
    if (
      this.props.match.path === '/event-dashboard/:eventDashboardId'
      || this.props.match.path === '/event-dashboard/:eventDashboardId/report'
      || this.props.match.path === '/event-dashboard/:eventDashboardId/list'
      || this.props.match.path === '/event-dashboard/:eventDashboardId/list\\::filterConfig'
    ) {
      return (
        <Route
          checkOrgLoaded
          exact
          path={[
            '/event-dashboard/:eventDashboardId',
            '/event-dashboard/:eventDashboardId/report',
            '/event-dashboard/:eventDashboardId/list',
            '/event-dashboard/:eventDashboardId/list\\::filterConfig',
          ]}
          render={(): React.ReactNode => (
            <EventDashboardSimple
              appReady={this.props.appReady}
              match={this.props.match}
              actions={this.props.actions}
              publicDashboard
              importButton={false}
              eventOnlyView
              organisations={this.props.organisations}
              paymentEvents={this.props.paymentEvents}
              subscriptionPayments={this.props.subscriptionPayments}
              eventDashboardId={this.props.match.params.eventDashboardId}
              {...this.props.paymentEventDashboard}
            />
          )}
        />
      );
    }
    return (
      <RenderContent
        className="event-dashboard-app vertical-stretch-off"
        match={this.props.match}
      >
        <Route
          exact
          path={['/events']}
          render={(): React.ReactNode => (
            <EventDashboardSimple
              appReady={this.props.appReady}
              match={this.props.match}
              actions={this.props.actions}
              importButton
              eventOnlyView={false}
              organisations={this.props.organisations}
              subscriptionPayments={this.props.subscriptionPayments}
              paymentEvents={this.props.paymentEvents}
              {...this.props.paymentEventDashboard}
            />
          )}
        />
        <Route
          exact
          path="/events/import"
          render={() => <ImportEvents {...this.props} />}
        />
        <Route
          path="/events/imports/:importId"
          render={() => <ImportEvents {...this.props} />}
        />
      </RenderContent>
    );
  }
}
